import { render, staticRenderFns } from "./editCRForm.vue?vue&type=template&id=04a2ec1f&scoped=true"
import script from "./editCRForm.vue?vue&type=script&lang=js"
export * from "./editCRForm.vue?vue&type=script&lang=js"
import style0 from "./editCRForm.vue?vue&type=style&index=0&id=04a2ec1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a2ec1f",
  null
  
)

export default component.exports